"use strict";

var _require = require('./make-auth-service'),
  makeAuthService = _require.makeAuthService;
module.exports = {
  makeAuthService: makeAuthService
};